export enum EVENT_TYPES {
    FOOTBALL = 'FOOTBALL',
    BASKETBALL = 'BASKETBALL',
    VOLLEYBALL = 'VOLLEYBALL',
    SQUASH = 'SQUASH',
    TENNIS = 'TENNIS',
}

export const eventTypeMap = {
    FOOTBALL: 'Football',
    BASKETBALL: 'Basketball',
    VOLLEYBALL: 'Volleyball',
    SQUASH: 'Squash',
    TENNIS: 'Tennis',
};

export enum LANGUAGES {
    EN = 'EN',
    PL = 'PL',
    ES = 'ES',
    IT = 'IT',
}

export const languageMap = {
    EN: 'English',
    PL: 'Polski',
    ES: 'Español',
    IT: 'Italiano',
};

export const eventTypeOptions = [
    { id: EVENT_TYPES.FOOTBALL, label: eventTypeMap.FOOTBALL },
    { id: EVENT_TYPES.BASKETBALL, label: eventTypeMap.BASKETBALL },
    { id: EVENT_TYPES.VOLLEYBALL, label: eventTypeMap.VOLLEYBALL },
    { id: EVENT_TYPES.SQUASH, label: eventTypeMap.SQUASH },
    { id: EVENT_TYPES.TENNIS, label: eventTypeMap.TENNIS },
];

export const languageOptions = [
    { id: LANGUAGES.EN, label: languageMap.EN },
    { id: LANGUAGES.PL, label: languageMap.PL },
    // TODO More translations
    // { id: LANGUAGES.ES, label: languageMap.ES },
    // { id: LANGUAGES.IT, label: languageMap.IT },
];

export const COLOURS = {
    BLACK: '#343434',
    GREEN: '#329f5b',
    RED: '#d22530',
    gray: '#919191',
    WHITE: '#faf8f8',
    LIGHT_RED: '#d22530',
    SUBTITLE: '#4b5563',
    ORANGE: '#ff8c00',
};

export enum SIZES {
    XS = 'xs',
    S = 's',
    M = 'm',
    L = 'l',
    XL = 'xl',
    XXL = 'xxl',
}

export const DEFAULT_AVATAR_URL =
    'https://sportwice-dev.s3.eu-central-1.amazonaws.com/static/defaultavatar.png';

export enum TEAM_NAMES {
    A = 'A',
    B = 'B',
}
